import accounting from 'accounting';
import Currency from './currency';

class Money {
  static parse(amountString, currency) {
    const cents = parseFloat(amountString) * Currency.get(currency).subunitToUnit;
    return new Money(cents, currency);
  }

  constructor(cents, currency) {
    this.cents = cents;
    this.currency = currency || 'USD';
  }

  toString() {
    const currencyData = Currency.get(this.currency);

    return accounting.formatMoney(
      this.cents / currencyData.subunitToUnit,
      {
        symbol: currencyData.symbol,
        precision: currencyData.precision,
      },
    );
  }

  toStringNoCents() {
    const currencyData = Currency.get(this.currency);

    return accounting.formatMoney(
      this.cents / currencyData.subunitToUnit,
      {
        symbol: currencyData.symbol,
        precision: 0,
      },
    );
  }

  toStringWithCurrency() {
    return `${this.toString()} ${this.currency}`;
  }
}

export default Money;
